import $ from "jquery";
import {scrollBarWidth} from "../../core/helpers/ScrollBarHelper";
import {isMobile} from "Core/screenSizes";

export const eventsSidebar = () => {
    let isOpen = false;

    $(document).on('click', '.more-btn__wrapper, .material-content-hashtag-list__more-btn', function () {
        isOpen = true;

        if ($(this).is('.division-more-btn')) {
            $(".sidebar.sidebar--league").toggleClass("sidebar_show");
            $(".sidebar__bg.sidebar__bg--league").toggleClass("sidebar__bg_active");
            $("html").addClass("sidebar__overflow").css("margin-right", scrollBarWidth());

            if (!isMobile()) {
                $(".header__inner").css("margin-right", scrollBarWidth());
            }

            return;
        }

        $(".sidebar").toggleClass("sidebar_show");
        $(".sidebar__bg").toggleClass("sidebar__bg_active");
        $("html").addClass("sidebar__overflow").css("margin-right", scrollBarWidth());

        if (!isMobile()) {
            $(".header__inner").css("margin-right", scrollBarWidth());
        }
    });

    $(document).on('click', '.sidebar__header-close', function () {
        isOpen = true;
        $(".sidebar").removeClass("sidebar_show");
        $(".sidebar__bg").removeClass("sidebar__bg_active");
        $("html").removeClass("sidebar__overflow").css("margin-right", "0");

        if (!isMobile()) {
            $(".header__inner").css("margin-right", "0");
        }
    });

    $(document).mouseup(function (e) {
        const container = $(".sidebar");

        if (!isOpen) {
            return;
        }

        isOpen = false;

        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $(".sidebar").removeClass("sidebar_show");
            $(".sidebar__bg").removeClass("sidebar__bg_active");
            $("html").removeClass("sidebar__overflow").css("margin-right", "0");

            if (!isMobile()) {
                $(".header__inner").css("margin-right", "0");
            }
        }
    });
};
